export const frameThickness = 60
export const glassHingeWidth = 150
export const glassHingeHeight = 40
export const glassLockWidth = 40
export const glassLockHeight = 80
